module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-view', {
    attrs: {
      "disableModify": "",
      "endpoint": _vm.endpoint + 'apikeys',
      "name": "API Key",
      "parentRoute": "apikeys",
      "permissions": "apikeys",
      "values": _vm.values
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07c33e3b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApiKeyEdit.vue
// module id = 412
// module chunks = 1